var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',_vm._b({staticClass:"form-row",class:{ inlineLabel: _vm.inlineLabel },attrs:{"display":"flex"}},'Box',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }